import i18next from 'i18next';
import {
    CHANGE_LANGUAGE,
    SETUP_APP,
    SET_PAGE_TITLE,
} from './types';
import { clearCache } from '../cache';

export const changeLanguage = (lang, force = false) => {
    return dispatch => {
        if (force || lang !== i18next.language) {
            i18next.changeLanguage(lang).then(() => {
                localStorage.setItem('language', lang);
                document.body.setAttribute('dir', i18next.dir(lang));
                dispatch({ type: CHANGE_LANGUAGE, payload: lang });
            });
        }
    };
};

export const setPageTitle = text => {
    return {
        type: SET_PAGE_TITLE,
        payload: text
    };
};

export const setupApp = payload => {
    return dispatch => {
        if (payload.languages) {
            const preferredLangauge = localStorage.getItem('language');
            if (preferredLangauge && payload.languages.includes(preferredLangauge)) {
                dispatch(changeLanguage(preferredLangauge));
            } else {
                dispatch(changeLanguage(payload.languages[0]));
            }
        }

        dispatch({ type: SETUP_APP, payload });
    };
};

export const resetState = () => {
    clearCache();
    window.location.reload();
    return { type: 'RESET' };
};